import { render } from "./HeaderPrecisionPicks.vue?vue&type=template&id=6cb4530c&ts=true"
import script from "./HeaderPrecisionPicks.vue?vue&type=script&lang=ts"
export * from "./HeaderPrecisionPicks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__